
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitokohlapurcabs() {



    const cardData =
    {
        keyword: 'Mumbai to Kolhapur Cab Service',
        heading: 'Vedant Travels: Mumbai to Kolhapur Cab Service',
        headingDescription: 'Vedant Travels offers reliable and budget-friendly Mumbai to Kolhapur Cabs, ensuring a safe and comfortable journey for every traveler. Our fares are transparent with no hidden costs, and we provide multiple cab options like Sedan, SUV, and Innova Crysta to match your budget and travel style. Whether you’re visiting the famous Mahalaxmi Temple, heading for business, or planning a family trip, our professional drivers guarantee timely pickups, smooth rides, and complete convenience. With 24x7 availability, clean vehicles, and easy online booking, Vedant Travels is your trusted choice for comfortable and affordable Mumbai to Kolhapur taxi services.',

        top: 'Top Places to Visit in Mahabaleshwar with Vedant Travels',

"topPlaces": [
    {
        "title": "Mahalaxmi Temple",
        "description": "One of the most revered pilgrimage sites, the Mahalaxmi Temple is dedicated to Goddess Mahalaxmi (Ambabai). It is believed that visiting this temple fulfills devotees' wishes and brings prosperity."
    },
    {
        "title": "Rankala Lake",
        "description": "A picturesque lake in Kolhapur, Rankala is perfect for boating, evening walks, and enjoying street food. The lake’s serene surroundings make it a great place to unwind."
    },
    {
        "title": "Panhala Fort",
        "description": "Located 20 km from Kolhapur, Panhala Fort is a historic site associated with Chhatrapati Shivaji Maharaj. The fort offers breathtaking views and is a paradise for history lovers and trekkers."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Perched on a hill, Jyotiba Temple is dedicated to Lord Jyotiba, believed to be an incarnation of Lord Shiva. The temple offers a spiritual retreat with panoramic views of the surroundings."
    },
    {
        "title": "New Palace Museum",
        "description": "A stunning royal palace built in the 19th century, the New Palace Museum houses artifacts, weapons, and paintings from the Maratha era. It is a must-visit for history and architecture enthusiasts."
    },
    {
        "title": "Kaneri Math – Siddhagiri Gramjivan Museum",
        "description": "This unique open-air museum depicts rural life in ancient India with lifelike sculptures. It is a great place to understand Indian culture and traditions."
    },
    {
        "title": "Kopeshwar Temple",
        "description": "Located in Khidrapur, this architectural marvel is dedicated to Lord Shiva. The temple’s intricate carvings and spiritual aura make it a hidden gem near Kolhapur."
    },
    {
        "title": "Bhavani Mandap",
        "description": "Once a royal court, Bhavani Mandap is now a heritage site displaying Maratha-era artifacts, statues, and historical documents. It is a must-visit for history lovers."
    },
    {
        "title": "Narsobawadi Datta Temple",
        "description": "Located on the banks of the Krishna River, this temple is dedicated to Lord Dattatreya and is a peaceful spiritual retreat."
    },
    {
        "title": "Gaganbawada Hill Station",
        "description": "A scenic hill station near Kolhapur, Gaganbawada offers breathtaking valley views, lush greenery, and trekking opportunities."
    }
],

"services": [
    {
        "name": "Mumbai to Kolhapur Cabs by Vedant Travels",
        "description": "Planning a trip to Kolhapur from Mumbai? Book your cab with Vedant Travels for a comfortable and reliable journey. Our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride to Kolhapur, whether you are going for business, leisure, or a pilgrimage."
    },
    {
        "name": "Mumbai to Kolhapur Taxi",
        "description": "For a hassle-free ride to Kolhapur from Mumbai, choose Vedant Travels. We offer professional taxi services with experienced drivers, ensuring comfort and safety throughout your journey. Enjoy a stress-free ride with our reliable taxi service."
    },
    {
        "name": "Kolhapur Darshan Taxi",
        "description": "Travel to Kolhapur for a spiritual experience with Vedant Travels. Our Kolhapur Darshan taxi service takes you to the famous temples and landmarks in Kolhapur. With comfortable, air-conditioned vehicles and experienced drivers, your pilgrimage will be smooth and memorable."
    },
    {
        "name": "Mumbai to Kolhapur One Way Cab",
        "description": "If you need a one-way taxi from Mumbai to Kolhapur, Vedant Travels provides convenient one-way cab services. Whether you're visiting for business or religious purposes, we ensure a comfortable and affordable one-way ride."
    },
    {
        "name": "Mumbai to Kolhapur Innova Crysta",
        "description": "For a luxurious and spacious ride, book an Innova Crysta for your Mumbai to Kolhapur trip. The Innova Crysta offers premium comfort and ample space, making it ideal for families or groups traveling to Kolhapur."
    },
    {
        "name": "Kolhapur Cab Booking",
        "description": "Booking a cab for your journey to Kolhapur is simple with Vedant Travels. You can easily book online or by calling our customer service team. Choose from a variety of vehicles to suit your travel preferences and group size."
    },
    {
        "name": "Mumbai to Kolhapur Car Rental",
        "description": "Rent a car for your trip to Kolhapur from Mumbai with Vedant Travels. We offer flexible car rental services, ensuring you travel in comfort and style. Choose the vehicle that best suits your needs, and enjoy a smooth and pleasant journey."
    },
    {
        "name": "Kolhapur Taxi Hire",
        "description": "Hire a taxi for your Kolhapur trip from Mumbai with Vedant Travels. We provide a range of vehicle options, including sedans and SUVs, to suit your preferences. Our experienced drivers ensure a safe and comfortable journey throughout your trip."
    },
    {
        "name": "Mumbai to Kolhapur Round Trip",
        "description": "Vedant Travels offers round-trip services from Mumbai to Kolhapur. Our round-trip taxi service ensures that you have a reliable and comfortable ride both to and from Kolhapur. Book your round-trip service today and enjoy a stress-free experience."
    },
    {
        "name": "Mumbai to Kolhapur Cab Fare",
        "description": "We provide competitive and transparent pricing for your Mumbai to Kolhapur journey. At Vedant Travels, you can expect fair and affordable cab fares with no hidden charges. Contact us for an accurate fare estimate based on your travel details."
    }
],



"tableData": [
    ["Mumbai to Kolhapur Cabs", "Mumbai to Kolhapur Taxi"],
    ["Kolhapur Darshan Taxi", "Mumbai to Kolhapur One Way Cab"],
    ["Mumbai to Kolhapur Innova Crysta", "Kolhapur Cab Booking"],
    ["Mumbai to Kolhapur Car Rental", "Kolhapur Taxi Hire"],
    ["Mumbai to Kolhapur Round Trip", "Mumbai to Kolhapur Cab Fare"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of time during your travel. Whether it's for a pilgrimage or a family trip, our drivers ensure timely pickups and drop-offs for your Mumbai to Kolhapur journey, ensuring a smooth and punctual experience."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Travel in comfort with our fleet of spacious and well-maintained vehicles. Designed for long-distance journeys, our cars provide ample legroom, air conditioning, and comfortable seating for a relaxing trip from Mumbai to Kolhapur."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and skilled in long-distance travel. They are familiar with the routes to Kolhapur and ensure a smooth, safe, and efficient ride, following the best routes to make the journey comfortable and enjoyable."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive pricing with no hidden charges. Our transparent pricing ensures that you know exactly what you are paying for, providing great value for your money while traveling from Mumbai to Kolhapur."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and worry-free journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you want to travel early in the morning or return late at night, Vedant Travels is available round the clock. Our customer support team is ready to assist with your booking at any time of the day or night."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Kolhapur cab with Vedant Travels is simple and convenient. You can book easily through our website or mobile app, or contact our customer service team for any assistance with your reservations."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer flexible and customized travel packages for your Kolhapur journey. Whether you are visiting for a religious trip, a family vacation, or business, we can tailor the journey according to your preferences and schedule."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Kolhapur cab with Vedant Travels?',
            answer: 'You can book your cab online via our website or mobile app. Alternatively, our customer service team is available to assist you with booking over the phone.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced and trained for long-distance travel. They are well-versed with the routes to Kolhapur, ensuring a smooth and safe journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Kolhapur travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are equipped for a comfortable and enjoyable journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Kolhapur cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip to Kolhapur?',
            answer: 'Yes, you can book a round-trip cab for your Mumbai to Kolhapur journey. Simply provide your return details during booking, and we’ll ensure a smooth return trip.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront. We believe in complete transparency, ensuring no hidden costs during or after your trip.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Kolhapur?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Kolhapur journey. Explore famous attractions like the Mahalaxmi Temple, Rankala Lake, and the Kolhapur Fort with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Kolhapur cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or special luggage needs, please let us know at the time of booking, and we will make necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Kolhapur?',
            answer: 'Yes, we provide corporate travel services for business trips, conferences, and team outings to Kolhapur. We ensure a professional and comfortable experience for corporate clients.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Kolhapur travel?',
            answer: 'Vedant Travels offers a reliable, comfortable, and affordable travel experience. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure that your journey to Kolhapur is smooth, safe, and memorable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sameer Patil",
            title: "Traveler",
            quote: "I traveled from Mumbai to Kolhapur with Vedant Travels for a religious trip. The vehicle was comfortable, and the driver was very professional and knowledgeable. I highly recommend their services for long trips!",
            rating: 5,
        },
        {
            name: "Mrs. Shilpa Deshmukh",
            title: "Family Traveler",
            quote: "Our family had a wonderful trip to Kolhapur with Vedant Travels. The car was spacious, and the driver was courteous and punctual. We had a smooth journey, and the entire experience was great. Will definitely use them again!",
            rating: 5,
        },
    ];
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    

 const url = "https://www.vedanttravels.in/mumbai-to-kolhapur-cabs";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/mumbai-to-kolhapur-cabs-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Kolhapur Cabs | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/mumbai-to-kolhapur-cabs.jpg",
    "description": "Book Mumbai → Kolhapur cabs — Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, professional chauffeurs, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 30112,          // within 8k–180k
      "reviewCount": 20120
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "4499",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Mumbai to Kolhapur Cabs",
        "description": "Mumbai → Kolhapur taxi booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, flexible halts, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Mumbai to Kolhapur Cabs", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Mumbai", "Navi Mumbai", "Thane", "Kolhapur", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 159842      // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Mumbai to Kolhapur Cabs",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way & round-trip taxi from Mumbai/Navi Mumbai/Thane to Kolhapur — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "mumbai-kolhapur-cabs",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "4499",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 30112,      // within 8k–180k
            "reviewCount": 20120
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Traveler" },
            "datePublished": "2025-07-20",
            "reviewBody": "Bandra to Kolhapur one-way with a breakfast stop at Satara. Clean Innova and courteous chauffeur.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Temple Visit" },
            "datePublished": "2025-05-11",
            "reviewBody": "Comfortable Sedan to Mahalaxmi Temple with return the next day. Clear fare and on-time pickup.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the starting fare from Mumbai to Kolhapur?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹4499. Final fare depends on car type, pickup time, route, and any sightseeing/waiting." }
          },
          {
            "@type": "Question",
            "name": "Do you cover pickups across Mumbai, Navi Mumbai, and Thane?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes—Bandra, Andheri, BKC, Dadar, Thane, Borivali, and Navi Mumbai (Vashi/Belapur/Kharghar), plus T1/T2 airport transfers." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway/highway tolls and parking included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway/major tolls. Any parking/entry or extended waiting is shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—AC, clean, GPS-enabled, with professional chauffeurs." }
          }
        ]
      }
    ]
  };




  
   
      


    return (
        <div>
           
            <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Mumbai to Kolhapur Cabs | One-Way & Round Trip Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book Mumbai → Kolhapur cabs at ₹4499 onwards. Sedan, SUV, Innova Crysta. Fixed fares, flexible halts, on-time pickup, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Mumbai to Kolhapur Cabs, Mumbai to Kolhapur Taxi, One Way Cab Mumbai Kolhapur, Innova Mumbai to Kolhapur, Navi Mumbai to Kolhapur Taxi"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Mumbai to Kolhapur Cabs | One-Way & Round Trip Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable Mumbai → Kolhapur cabs—transparent fares, clean cars & pro drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mumbai to Kolhapur Cabs | One-Way & Round Trip Taxi" />
        <meta name="twitter:description" content="Mumbai → Kolhapur cabs at ₹4499 onwards. Instant confirmation, 24×7 support." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>

  
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokohlapurcabs;